import React from 'react';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Solution } from './components/sections/Solution';
import { WhatsInside } from './components/sections/WhatsInside';
import { Comparison } from './components/sections/Comparison';
import { Pricing } from './components/sections/Pricing';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { FAQ } from './components/sections/FAQ';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-stone-900 selection:bg-amber-200 selection:text-amber-900" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <Solution data-id="element-4" />
        <WhatsInside data-id="element-5" />
        <Comparison data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Pricing data-id="element-8" />
        <Guarantee data-id="element-9" />
        <FAQ data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}